/**
 * Datos precargados para el render estático del build (scripts/ssr/render-paginas.cjs).
 *
 * El prerender renderiza las páginas públicas con react-dom/server, donde los
 * useEffect no corren: los datos que en el navegador llegan por fetch (precios,
 * opiniones) se cargan acá ANTES del render para que queden escritos en el HTML
 * que leen Google y los asistentes de IA. En el navegador este almacén está
 * siempre vacío y las páginas cargan como siempre.
 */
const store: Record<string, unknown> = {};

export function setSsrData(key: string, value: unknown): void {
  store[key] = value;
}

export function getSsrData<T>(key: string): T | undefined {
  return store[key] as T | undefined;
}
